import React from 'react'
import { Field, ErrorMessage } from 'formik'
import Title from '../Title'
import { styled } from 'linaria/react'
import { theme } from '../../Theme'

const CustomFieldContainer = styled.div`
   input {
      min-height: 2.75rem;
      border-radius: 0.25rem;
      border: solid 2px #707070;
      background-color: #fbfbfb;
      font-family: var(--font-grotesk);
      font-size: 1rem;
      font-weight: 600;
      width: 100%;
      text-indent: 1rem;
   }
   textarea {
      min-height: 5rem;
      border-radius: 0.25rem;
      border: solid 2px #707070;
      background-color: #fbfbfb;
      padding: 0.5rem 1rem;
      font-family: var(--font-grotesk);
      font-size: 1rem;
      font-weight: 600;
      width: 100%;
   }

   input::placeholder {
      color: #000;
      opacity: 0.43;
   }

   .error-message {
      color: green;
      font-size: 1rem;
      font-family: var(--font-grotesk);
      font-weight: 600;
      ${theme.below.md} {
         font-size: 14px;
      }
   }

   .error-background {
      background-color: #ffe9e6;
   }

   .form-control:focus {
      border-color: #195178;
   }
`

function VbDynamicField({
   id,
   name,
   label,
   type,
   placeholder,
   isTextArea,
   required,
   className,
   ...inputProps
}) {
   return (
      <Field
         id={id}
         name={name}
         render={({ field, form: { touched, errors } }) => {
            return (
               <CustomFieldContainer className={className}>
                  <div className="d-flex justify-content-between align-items-center">
                     <Title
                        size={'1rem'}
                        fontFamily="HKGrotesk"
                        weight={500}
                        className="mb-2"
                     >
                        {label}{required ? "*" : ''}
                     </Title>
                     <span className="error-message">
                        <ErrorMessage name={name} />
                     </span>
                  </div>
                  {isTextArea ? (
                     <textarea
                        {...field}
                        id={id}
                        disabled={false}
                        name={name}
                        placeholder={placeholder}
                        type={type}
                        aria-label={name}
                        className={
                           errors?.[name] &&
                           touched?.[name] &&
                           'error-background'
                        }
                        {...inputProps}
                     />
                  ) : (
                     <input
                        {...field}
                        id={id}
                        disabled={false}
                        name={name}
                        placeholder={placeholder}
                        type={type}
                        aria-label={name}
                        className={
                           errors?.[name] &&
                           touched?.[name] &&
                           'error-background'
                        }
                        {...inputProps}
                     />
                  )}
               </CustomFieldContainer>
            )
         }}
      />
   )
}

export default VbDynamicField
